import {TheMask} from 'vue-the-mask';
import Axios from "axios";

export default {
    components: {TheMask},

    watch: {
        'email': {
            immediate: true,
            handler: function (email, oldEmail) {
                if (! email || !email.length) {
                    this.emailError = null;
                } else {
                    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                        this.emailError = 'That email address isn\'t valid.';
                    } else {
                        this.emailError = false;
                    }
                }
            }
        }
    },

    data() {
        let tokens = require('vue-the-mask').tokens;

        return {
            error: null,
            loading: false,
            email: null,
            emailError: null,
            phoneNumber: null,
            numberError: null,
            sendStartMessage: null,
            emailRequired: true,
            numberRequired: true,
            resetEmail: true,
            emailAddressStatus: null,
            multiRequest: false,
            hexTokens: {
                ...tokens,
                ...{
                    F: {
                        pattern: /\d/,
                        transform: v => ['0', '1'].includes(v) ? '' : v,
                    }
                }
            },
        }
    },

    methods: {
        saveBoth() {
            this.error = false;
            this.loading = true;
            this.multiRequest = true;

            let requests = [];

            if (this.emailRequired || this.email) {
                requests.push(this.saveEmail());
            }

            if (this.numberRequired || this.phoneNumber) {
                requests.push(this.savePhoneNumber());
            }

            Axios.all(requests).then(Axios.spread(() => {
                console.log(this.emailError, this.numberError);

                if (! this.emailError && ! this.numberError) {
                    if (this.resetEmail) this.email = null;
                    this.phoneNumber = null;

                    this.done();
                }

                this.loading = false;
            }));
        },

        saveEmail() {
            this.error = false;
            this.loading = true;

            let payload = { email: this.email };

            if (this.token) {
                payload.token = this.token;
            }

            if (this.emailAddressStatus) {
                payload.email_address_status = this.emailAddressStatus;
            }

            return this.$http
                .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/email-addresses`, payload)
                .then(() => {
                    this.loading = false;

                    this.emailError = false;
                    if (this.resetEmail) this.email = null;

                    if (! this.multiRequest) this.done();
                }, error => {
                    this.loading = false;

                    if (error.status === 422 && error.body.hasOwnProperty('message')) {
                        this.emailError = error.body.message;
                    } else {
                        this.emailError = 'Something went wrong.';
                    }
                });
        },

        savePhoneNumber() {
            this.error = false;
            this.loading = true;

            return this.$http.post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/phone-numbers`, {
                phone_number: this.phoneNumber,
            }).then(response => {
                this.loading = false;

                this.numberError = false;

                if (response.hasOwnProperty('body') && response.body.hasOwnProperty('send_start_to') && response.body.send_start_to) {
                    this.sendStartMessage = response.body.send_start_to;
                }
            }, error => {
                this.loading = false;

                if (error.status === 422 && error.body.hasOwnProperty('message')) {
                    this.numberError = error.body.message;
                } else {
                    this.numberError = 'Something went wrong.';
                }
            });
        },
    }
}
